import { render, staticRenderFns } from "./RadioItem.vue?vue&type=template&id=322b43a2&scoped=true"
import script from "./RadioItem.vue?vue&type=script&lang=js"
export * from "./RadioItem.vue?vue&type=script&lang=js"
import style0 from "./RadioItem.vue?vue&type=style&index=0&id=322b43a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322b43a2",
  null
  
)

export default component.exports